<template>
  <div class="product-stock mt-3">
    <template v-if="optionType == 'multiple'">
      <template v-if="productcategory">
        <v-layout wrap>
          <v-flex xs12 sm7 md8 class="px-1">
            <v-layout>
              <v-flex>
                <h3 class="headline mt-2">{{ $t('option') | capitalize }}</h3>
              </v-flex>
              <v-flex class="text-xs-right">
                <v-btn class="mt-3" small outline color="primary" @click="turnOffMultiOption">{{
                  $t('Switch to single option')
                }}</v-btn>
              </v-flex>
            </v-layout>
            <product-stock-category
              v-model="productcategory"
              :totalOptions="totalOptions"
              @addOption="addOption"
              @deleteOption="deleteOption"
              @addCategory="addCategory"
              @deleteCategory="deleteCategory"
            ></product-stock-category>
          </v-flex>
          <v-flex xs12 sm5 md4 class="px-1" v-if="product">
            <h3 class="headline mt-2">{{ $t('preview') }}</h3>
            <preview-product
              v-model="currentOption"
              :product="product"
              :productcategory="productcategory"
              :productstock="productstock"
            ></preview-product>
          </v-flex>
        </v-layout>
      </template>

      <v-layout>
        <v-flex>
          <h3 class="headline mt-3">{{ $t('Stock Management') }}</h3>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn outline color="primary" class="mt-3" @click="showManageStock = true">
            {{ $t('Edit as a group') }}
          </v-btn>
          <v-dialog v-model="showManageStock" persistent max-width="600">
            <v-card>
              <div class="text-xs-right">
                <v-btn small fab flat @click="showManageStock = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <v-layout wrap class="form-control">
                  <v-flex xs12 sm3 class="px-1">
                    <input
                      type="text"
                      :name="'quantity'"
                      maxlength="4"
                      :data-vv-name="'quantity'"
                      :data-vv-as="$t('quantity')"
                      class="form-control"
                      :placeholder="$t('quantity')"
                      v-model="applyall.quantity"
                      @blur="applyall.quantity = numberOnly($event)"
                    />
                  </v-flex>
                  <v-flex xs12 sm3 class="px-1">
                    <input
                      type="text"
                      :name="'price'"
                      :data-vv-name="'price'"
                      :data-vv-as="$t('price')"
                      class="form-control"
                      :placeholder="$t('price')"
                      v-model="applyall.price"
                      @blur="applyall.price = decimalOnly($event)"
                    />
                  </v-flex>
                  <v-flex xs12 sm3 class="px-1">
                    <input
                      type="text"
                      :name="'discountprice'"
                      :data-vv-name="'discountprice'"
                      :data-vv-as="$t('discountprice')"
                      class="form-control"
                      :placeholder="$t('discountprice')"
                      v-model="applyall.discountprice"
                      @blur="applyall.discountprice = decimalOnly($event)"
                    />
                  </v-flex>
                  <v-flex xs12 sm3 class="px-1">
                    <input
                      type="text"
                      :name="'sku'"
                      :data-vv-name="'sku'"
                      :data-vv-as="$t('sku')"
                      class="form-control"
                      :placeholder="$t('sku')"
                      v-model="applyall.sku"
                    />
                  </v-flex>
                </v-layout>

                <div class="text-xs-center">
                  <v-btn @click="applyAll" color="primary" depressed>Apply All</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>

      <div class="mb-3" v-if="productcategory && productcategory.length > 0">
        <div style="overflow-x: auto">
          <table>
            <template v-for="(cat, index) in productcategory[0].option">
              <template v-if="productcategory.length > 1">
                <template v-for="(option, oindex) in productcategory[1].option">
                  <product-stock-item2
                    style="border-top: 1px solid #eee; border-left: 1px solid #eee"
                    :key="`${cat}_${option}_${index}_${oindex}`"
                    v-if="stock[index] && stock[index][oindex]"
                    v-model="stock[index][oindex]"
                    :index="index"
                    :oindex="oindex"
                    :category="cat"
                    :option="option"
                    @onMove="onMoveMulti(index, $event)"
                  >
                    <td
                      v-if="oindex == 0"
                      :rowspan="productcategory[1].option.length"
                      style="border-right: 1px solid #eee; min-width: 100px"
                      class="px-2 py-1 text-xs-center"
                    >
                      <template v-if="cat && cat.toString().trim() != ''">{{ cat }}</template>
                      <template v-else>{{ $t('option') }}</template>
                      <uploadfile
                        :height="50"
                        v-model="stock[index][oindex][7]"
                        data-vv-as="Stock Image"
                        @onUploaded="onUploadImage(index, $event)"
                      >
                        <v-btn flat fab small>
                          <v-icon small>camera_alt</v-icon>
                        </v-btn>
                      </uploadfile>
                    </td>
                    <td
                      style="border-right: 1px solid #eee; min-width: 100px"
                      class="px-2 py-1 text-xs-center"
                    >
                      <template v-if="option && option.toString().trim() != ''">{{
                        option
                      }}</template>
                      <template v-else>{{ $t('option') }}</template>
                    </td>
                  </product-stock-item2>
                </template>
              </template>
            </template>
          </table>
        </div>
      </div>
    </template>
    <template v-else>
      <v-layout>
        <v-flex>
          <h3 class="headline mt-2">{{ $t('stock') }}</h3>
        </v-flex>
        <!-- <v-flex class="text-xs-right">
          <v-btn class="mt-2" small outline color="primary" @click="turnOnMultiOption">{{
            $t('Switch to double option')
          }}</v-btn>
        </v-flex> -->
      </v-layout>
      <template v-if="productstock && productstock.length > 0">
        <product-stock-item
          v-for="(stock, index) in productstock"
          :key="'stock_' + index"
          :stockkey="index"
          :productstock="productstock"
          :index="index"
          v-model="productstock[index]"
          :max="productstock.length"
          @onDelete="deleteProductStock(index, stock[0])"
          @onMove="onMove(index, $event)"
        ></product-stock-item>
      </template>

      <a
        href="javascript:void(0);"
        class="btn-add text-xs-center"
        @click="addProductStock()"
        style="margin-bottom: 15px; padding: 15px 0; text-decoration: none"
      >
        <span class="fa fa-plus"></span>
        {{ $t('add new stock') }}
      </a>
    </template>
  </div>
</template>

<script>
import AddStock from './AddStock'
import ProductStockItem from './ScgdisProductStockItem'

import ProductStockItem2 from './ProductStockItem2'
import { mapGetters } from 'vuex'

import ProductStockCategory from './ProductStockCategory'
import uploadfile from '@/components/elements/uploadfile'

import PreviewProduct from './PreviewProduct'

export default {
  props: ['value', 'category', 'product'],
  inject: ['$validator'],
  data: function () {
    return {
      productstock: null,
      productcategory: null,
      newProductStock: {
        option: null,
        quantity: 0
      },
      min: 0,
      max: 999,
      isAdd: false,
      deletelist: [],
      stock: [[]],
      applyall: {
        quantity: null,
        price: null,
        discountprice: null,
        sku: null
      },
      currentOption: null,
      optionType: 'single',
      showManageStock: false,
      limitoption: 15
    }
  },
  mounted: async function () {
    this.initStock()
    this.productcategory = this.category
    if (this.productcategory && this.productcategory.length > 1) {
      this.optionType = 'multiple'
      this.productcategory = this.category
      this.initCategory()
    }

    await this.$nextTick()
    if (this.productstock.length == 0) {
      this.addProductStock()
    } else {
      for (let index = 0; index < this.productstock.length; index++) {
        this.productstock[index][6] = index
      }
      this.sortProductStock()
    }
  },
  components: {
    AddStock,
    ProductStockItem,
    ProductStockCategory,
    ProductStockItem2,
    uploadfile,
    PreviewProduct
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    totalOptions() {
      return this.productcategory
        .map((el) => {
          return el.option.length
        })
        .reduce((prev, cur) => {
          return prev + cur
        })
    }
  },
  methods: {
    async initCategory() {
      if (
        !this.productcategory ||
        this.productcategory.length == 0 ||
        this.productcategory[0].option.length == 0
      ) {
        if (this.productstock && this.productstock.length > 0) {
          var categoryoption = []
          this.productstock.map((el) => {
            categoryoption.push(el[1])
          })
          var category = {
            name: this.$t('option'),
            level: 0,
            option: categoryoption
          }

          this.productcategory = []
          this.productcategory.push(category)
        }
      }
      this.createStock()
    },
    async onUploadImage(index, url) {
      for (let oindex = 0; oindex < this.stock[index].length; oindex++) {
        this.$set(this.stock[index][oindex], 7, url)
      }
      if (this.optionType == 'multiple') {
        await this.$nextTick()
        this.buildStock(this.productcategory)
      }
    },
    initStock() {
      var stock = this.value
      if (this.category && this.category.length == 1) {
        if (this.category[0].option.length != stock.length) {
          var option = stock.map((el) => {
            return el[1]
          })
          this.$set(this.category[0], 'option', option)
        }
      }

      this.productstock = stock
    },
    onMoveMulti(index, payload) {},
    turnOnMultiOption() {
      this.optionType = 'multiple'
      this.initCategory()

      this.productcategory.push({
        level: 1,
        name: 'ขนาด',
        option: ['40']
      })
      this.createStock()
    },
    async turnOffMultiOption() {
      var result = await this.$swal.fire({
        title: this.$t('Are you sure you want to change back to use a single option?'),
        text: this.$t(
          'Be cautioned that this change may cause you to lose some of your stock information.'
        ),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        this.optionType = 'single'
        if (this.productcategory.length > 1) {
          this.deleteCategory(1)
        }
      }
    },
    applyAll() {
      this.stock.map((el, index) => {
        el.map((opt, oindex) => {
          if (this.applyall.quantity)
            this.$set(this.stock[index][oindex], 2, this.applyall.quantity)
          if (this.applyall.price) this.$set(this.stock[index][oindex], 3, this.applyall.price)
          if (this.applyall.discountprice)
            this.$set(this.stock[index][oindex], 4, this.applyall.discountprice)
          if (this.applyall.sku) this.$set(this.stock[index][oindex], 5, this.applyall.sku)
        })
      })
      this.applyall = {
        quantity: null,
        price: null,
        discountprice: null,
        sku: null
      }
      this.showManageStock = false
    },

    buildStock(category) {
      var stock = []
      var order = 0
      if (category && category.length > 0) {
        if (category[0].option && category[0].option.length > 0) {
          for (let index = 0; index < category[0].option.length; index++) {
            if (category.length > 1 && category[1].option.length > 0) {
              for (let oindex = 0; oindex < category[1].option.length; oindex++) {
                var tmp =
                  this.stock[index] && this.stock[index][oindex]
                    ? this.stock[index][oindex]
                    : [null, null, null, null, null, null, 0, null]

                tmp[1] = category[0].option[index] + '/' + category[1].option[oindex]
                tmp[6] = order
                stock.push(tmp)
                order++
              }
            } else {
              var tmp = this.stock && this.stock[index] ? this.stock[index] : undefined

              if (tmp) {
                tmp[1] = category[0].option[index]
                tmp[6] = order
                stock.push(tmp)
                order++
              }
            }
          }

          this.productstock = stock
          this.$emit('input', this.productstock)
        }
      }
    },
    createStock() {
      var stock = []
      if (
        this.productcategory &&
        this.productcategory.length > 0 &&
        this.productcategory[0].option.length > 0
      ) {
        this.productcategory[0].option.map((cat, index) => {
          var subStock = []
          if (this.productcategory.length > 1 && this.productcategory[1].option.length > 0) {
            this.productcategory[1].option.map((option, oindex) => {
              var findStock = this.productstock.find((el) => {
                return el[1] == `${cat}/${option}`
              })
              if (findStock) subStock.push(findStock)
              else subStock.push([null, `${cat}/${option}`, null, null, null, null, 0, null])
            })
          } else {
            var findStock = this.productstock.find((el) => {
              return el[1] == cat
            })
            if (findStock) subStock.push(findStock)
            else subStock.push([null, `${cat}`, null, null, null, null, 0, null])
          }
          stock.push(subStock)
        })
        // console.log(stock)
        this.stock = stock
      } else {
        this.stock = [[[null, null, null, null, null, null, 0, null]]]
      }
    },
    addOption(sindex) {
      // console.log('add option', sindex)
      if (sindex == 0) {
        // this.stock
        var stock = []
        if (this.productcategory.length > 1) {
          for (let index = 0; index < this.productcategory[1].option.length; index++) {
            stock.push([null, null, null, null, null, null, 0, null])
          }
          this.stock.push(stock)
        } else {
          this.stock.push([[null, null, null, null, null, null, 0, null]])
        }
      } else if (sindex == 1) {
        this.stock.map((el, index) => {
          this.stock[index].push([null, null, null, null, null, null, 0, null])
        })
      }
    },
    deleteOption({ sindex, oindex }) {
      if (sindex == 0) {
        this.stock.splice(sindex, 1)
      } else if (sindex == 1) {
        this.stock.map((el, index) => {
          this.stock[index].splice(oindex, 1)
        })
      }
    },
    addCategory(sindex, text = null) {
      if (sindex == 0) {
        var cat = []
        for (let index = 0; index < this.productcategory[0].option.length; index++) {
          var stock = []
          for (let oindex = 0; oindex < this.productcategory[1].option.length; oindex++) {
            stock.push([null, text, null, null, null, null, 0, null])
          }
          cat.push(stock)
        }
        this.stock = cat
      } else if (sindex == 1) {
        var cat = []
        for (let index = 0; index < this.productcategory[0].option.length; index++) {
          var stock = []
          for (let oindex = 0; oindex < this.productcategory[1].option.length; oindex++) {
            stock.push([null, text, null, null, null, null, 0, null])
          }
          cat.push(stock)
        }
        this.stock = cat
      }
    },
    deleteCategory(sindex) {
      if (sindex == 0) {
      } else if (sindex == 1) {
        var cat = []
        this.productcategory.splice(sindex, 1)
      }
    },
    updateStock() {
      var stock = []
      if (
        this.productcategory &&
        this.productcategory.length > 0 &&
        this.productcategory[0].option.length > 0
      ) {
        this.productcategory[0].option.map((cat, index) => {
          var subStock = []
          if (this.productcategory.length > 1 && this.productcategory[1].option.length > 0) {
            this.productcategory[1].option.map((option, oindex) => {
              subStock.push([null, `${cat}/${option}`, null, null, null, null, 0, null])
            })
          } else {
            var op = this.value.find((s) => {
              return s[1] == cat
            })
            subStock.push([null, `${cat}`, null, null, null, null, 0, null])
          }
          stock.push(subStock)
        })
        this.stock = stock
      }
    },
    sortProductStock: function () {
      this.productstock = this.productstock.sort(function (a, b) {
        if (a[6] > b[6]) {
          return 1
        } else if (a[6] < b[6]) {
          return -1
        } else {
          return 0
        }
      })
    },
    addProductStock: function (key) {
      let vm = this

      vm.productstock.push([
        null,
        key ? key : null,
        null,
        null,
        null,
        null,
        vm.productstock.length - 1,
        null
      ])
    },
    deleteProductStock: function (index, id) {
      let vm = this

      if (vm.productstock.length <= 1) {
        vm.$swal.fire({
          title: vm.$t('The stock must have at least 1 item'),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm'),
          reverseButtons: true
        })
        return false
      }
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: (vm.productstock[index][1] ? vm.productstock[index][1] : '').replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            if (id != null) {
              vm.deletelist.push(id)
              vm.$emit('deleteStock', id)
            }
            vm.productstock.splice(index, 1)
          }
        })
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction == 'up') {
        vm.$set(vm.productstock[index], 6, index - 1)
        vm.$set(vm.productstock[index - 1], 6, index)
      } else if (direction == 'down') {
        vm.$set(vm.productstock[index], 6, index + 1)
        vm.$set(vm.productstock[index + 1], 6, index)
      }
      vm.sortProductStock()
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.productstock = this.value
      // if (this.productstock.length > 0) {
      //   for (let index = 0; index <script this.productstock.length; index++) {
      //     console.log('STOCK LENGTH:', this.productstock.length)
      //     this.productstock[index][6] = index
      //   }
      // }
    },
    productstock: function () {
      this.$emit('input', this.productstock)
    },
    stock: {
      deep: true,
      handler: async function (newVal) {
        // if (
        //   this.$store.state.centralPage.includes(this.selectedBot.pageid) ||
        //   ['111006887303026', '116989963422911', '104974550989962', '998122266996445'].includes(
        //     this.selectedBot.pageid
        //   )
        // ) {
        if (this.optionType == 'multiple') {
          await this.$nextTick()
          this.buildStock(this.productcategory)
        }
        // }
      }
    },
    productcategory: {
      deep: true,
      handler: async function (newVal) {
        // if (
        //   this.$store.state.centralPage.includes(this.selectedBot.pageid) ||
        //   ['111006887303026', '116989963422911', '104974550989962', '998122266996445'].includes(
        //     this.selectedBot.pageid
        //   )
        // ) {
        if (this.optionType == 'multiple') {
          await this.$nextTick()
          this.buildStock(newVal)
          this.$emit('updateCategory', newVal)
        }
        // }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ScgdisProductStock.vue